module.exports = __webpack_public_path__ + "img/Christmas Island.db8b28ac.svg";